import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import { TranslatedTextV2 } from '../../../atoms/TranslatedText';

interface ISelectFieldProps {
  label: {
    translationKey: string;
    defaultText: string;
  };
  field: string;
  value: string | number | null;
  options: Array<{
    label: string;
    id: string | number;
  }>;
  onValueChange: (key: string, value: string | number) => void;
}
export const SelectField = (props: ISelectFieldProps) => {
  return (
    <Box>
      <Typography style={{ fontWeight: 500, fontSize: '14px' }}>
        <TranslatedTextV2
          translationKey={props.label.translationKey}
          defaultText={props.label.defaultText}
        />
      </Typography>
      <FormControl variant={'outlined'} fullWidth margin={'dense'}>
        <Select
          value={props.value ?? 'null'}
          onChange={(event: any) =>
            props.onValueChange(props.field, event.target.value)
          }
        >
          <MenuItem value={'null'}>
            <TranslatedTextV2 translationKey={''} defaultText={'Select...'} />
          </MenuItem>
          {props.options.map(
            (element: { label: string; id: string | number }) => (
              <MenuItem key={element.id} value={element.id}>
                {element.label}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectField;
